


































































































import Basic from '@/components/widgets/Basic.vue';
import { default as Component } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import HsgProductImage from '@/components/widgets/hsg/HsgProductImage.vue';

import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';

import Api from '@/interfaces/Api';
import Format from '@/interfaces/Format';
import Tracking from '@/interfaces/Tracking';

const ApiProvider = IocContainer.get<Api>(SERVICES.API);
const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);
const trackingProvider = IocContainer.get<Tracking>(SERVICES.TRACKING);

@Component({
  components: {
    'product-image': HsgProductImage
  },
  filters: {
    date: formatProvider.date(),
    euro: formatProvider.euro(),
    euroFull: formatProvider.euroFull(),
    zip: formatProvider.zip()
  },
  props: {
    product: Object,
    position: Number,
    isMobile: Boolean
  }
})
export default class HsgProductInfoWidget extends Basic {
  protected displayDetails = true;
  private descriptionArrowClass = 'down';
  private selectProduct = false;

  get productName(): string {
    return this.$props.product.productName;
  }

  get descriptionExternal(): string {
    return this.$props.product.descriptionExternal;
  }

  @Watch('selectProduct')
  public onSelectProduct(): void {
    const data = {
      productCode: this.$props.product.productCode
    };
    ApiProvider.sessionUpdate(data)
      .then(() => {
        this.store.commit('SET_SESSION', data);
        this.$parent.$emit('productSubmit', data);
        trackingProvider.productSelected(this.sessionState, this.$props.product);
      })
      .catch((error) => {
        if (typeof error.response !== 'undefined' && error.response.data.error.message === 'session outdated') {
          localStorage.removeItem(process.env.VUE_APP_SESSION_STORAGE_KEY);
          window.location.href = document.referrer || window.location.origin;
        }
      });
  }

  public getUrl(text: string): string {
    if (text) {
      const regex =
        // eslint-disable-next-line no-useless-escape
        /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;
      const results = text.match(regex);
      return results ? results[0] : '';
    }

    return '';
  }

  protected getDisclaimer(product: { totalBasePriceBonusBruttoMonth: number }): string {
    const converter = formatProvider.euro();
    return this.$t('product.widget.tariff.information.disclaimer', {
      zip: this.sessionState.zip,
      usage: this.sessionState.usage,
      price: converter(product.totalBasePriceBonusBruttoMonth)
    }).toLocaleString();
  }

  protected chooseProduct(): void {
    this.selectProduct = true;
  }

  private displayDescriptionDetails(): void {
    this.displayDetails = !this.displayDetails;
    this.descriptionArrowClass = this.descriptionArrowClass === 'down' ? 'up' : 'down';
  }
}
